import { AlertTriangle, Check, CircleDashed, Loader2, WifiOff } from 'lucide-react'
import type { DraftState } from './useOfflineDraft'

const LABELS: Record<Exclude<DraftState, 'idle'>, string> = {
  pending: 'Wijzigingen worden zo opgeslagen',
  saving: 'Opslaan…',
  saved: 'Concept opgeslagen',
  offline: 'Niet opgeslagen – geen verbinding',
  error: 'Niet opgeslagen – de tekst staat nog op dit apparaat',
}

const TONES: Record<Exclude<DraftState, 'idle'>, string> = {
  pending: 'text-muted-foreground',
  saving: 'text-muted-foreground',
  saved: 'text-green-700',
  offline: 'text-amber-700',
  error: 'text-destructive',
}

/** The autosave indicator of the memo (Dutch; the founder `AutosaveIndicator` is English). */
export function DraftStatus({ state }: { state: DraftState }) {
  if (state === 'idle') return null
  const Icon =
    state === 'saving'
      ? Loader2
      : state === 'saved'
        ? Check
        : state === 'offline'
          ? WifiOff
          : state === 'error'
            ? AlertTriangle
            : CircleDashed
  return (
    <p role="status" className={`inline-flex items-center gap-1 text-sm ${TONES[state]}`}>
      <Icon className={`size-3.5 shrink-0 ${state === 'saving' ? 'animate-spin' : ''}`} aria-hidden />
      {LABELS[state]}
    </p>
  )
}
